import { render } from "./student-reviews.vue?vue&type=template&id=6f026f6f"
import script from "./student-reviews.vue?vue&type=script&lang=js"
export * from "./student-reviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__